import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo mi guía?',
  answer: 'Inmediatamente después del pago recibes un email con el enlace de descarga. El PDF es tuyo para siempre.'
}, {
  question: '¿Qué métodos de pago aceptan?',
  answer: 'Aceptamos tarjeta de crédito, débito y otros métodos disponibles en tu país a través de nuestra plataforma segura.'
}, {
  question: '¿En qué moneda es el precio?',
  answer: 'El precio es US$ 6.36 (dólares estadounidenses). Tu banco puede convertirlo automáticamente a tu moneda local.'
}, {
  question: '¿Necesito conocimientos de nutrición?',
  answer: 'No. La guía está escrita en lenguaje simple y directo. Cualquier persona puede seguirla.'
}, {
  question: '¿Funciona si tengo una dieta especial?',
  answer: 'Los principios son adaptables a diferentes estilos de alimentación. Si tienes una condición médica específica, consulta con tu médico.'
}, {
  question: '¿En qué formato viene?',
  answer: 'En formato PDF, compatible con teléfono, tablet y computadora. No necesitas ninguna app especial.'
}, {
  question: '¿Hay garantía?',
  answer: 'Sí. Si no estás satisfecha en 7 días, escríbenos y te devolvemos tu dinero. Sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-wellness-light-sage py-20 px-6" id="faq" data-id="element-38">
      <div className="max-w-2xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-wellness-dark mb-4" data-id="element-41">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-42">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className="bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 py-4 flex justify-between items-center text-left" data-id="element-44">
                <span className="font-medium text-wellness-dark pr-4" data-id="element-45">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="flex-shrink-0 text-wellness-green" data-id="element-46">
                  <ChevronDown className="w-5 h-5" data-id="element-47" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-48">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-49">
                    <div className="px-5 pb-4 text-wellness-dark/70 border-t border-wellness-light-sage pt-3" data-id="element-50">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}